/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestApproveUserRequest } from './RequestApproveUserRequest';
import {
    RequestApproveUserRequestFromJSON,
    RequestApproveUserRequestFromJSONTyped,
    RequestApproveUserRequestToJSON,
    RequestApproveUserRequestToJSONTyped,
} from './RequestApproveUserRequest';

/**
 * 
 * @export
 * @interface RequestApproveUserRequestWrapper
 */
export interface RequestApproveUserRequestWrapper {
    /**
     * 
     * @type {Array<RequestApproveUserRequest>}
     * @memberof RequestApproveUserRequestWrapper
     */
    req?: Array<RequestApproveUserRequest>;
}

/**
 * Check if a given object implements the RequestApproveUserRequestWrapper interface.
 */
export function instanceOfRequestApproveUserRequestWrapper(value: object): value is RequestApproveUserRequestWrapper {
    return true;
}

export function RequestApproveUserRequestWrapperFromJSON(json: any): RequestApproveUserRequestWrapper {
    return RequestApproveUserRequestWrapperFromJSONTyped(json, false);
}

export function RequestApproveUserRequestWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestApproveUserRequestWrapper {
    if (json == null) {
        return json;
    }
    return {
        
        'req': json['req'] == null ? undefined : ((json['req'] as Array<any>).map(RequestApproveUserRequestFromJSON)),
    };
}

export function RequestApproveUserRequestWrapperToJSON(json: any): RequestApproveUserRequestWrapper {
    return RequestApproveUserRequestWrapperToJSONTyped(json, false);
}

export function RequestApproveUserRequestWrapperToJSONTyped(value?: RequestApproveUserRequestWrapper | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'req': value['req'] == null ? undefined : ((value['req'] as Array<any>).map(RequestApproveUserRequestToJSON)),
    };
}

